import { hydrateRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import HotelFinderPreambleView from '../shared/views/hotelFinderPreamble/hotelFinderPreambleView';

const initialStateHotelFinderPreamble =
  window.__INITIAL_STATE_HOTEL_FINDER_PREAMBLE__;
delete window.__INITIAL_STATE_HOTEL_FINDER_PREAMBLE__;
const hotelFinderPreambleRoot = document.getElementById(
  'hotel-finder-preamble-view',
);

if (hotelFinderPreambleRoot) {
  const { hotelInformation, siteId, legacyMode, itemType } =
    initialStateHotelFinderPreamble;

  hydrateRoot(
    hotelFinderPreambleRoot,
    <Globals siteId={siteId} legacyMode={legacyMode}>
      <HotelFinderPreambleView
        hotelInformation={hotelInformation}
        itemType={itemType}
      />
    </Globals>,
  );
}
